/*
  Redesign PDP — shows "Add to Cart - {price}" on the add-to-cart button.
  The button label comes from a shared locale key ("Shop Now") that other
  templates rely on, so it is composed on the client for the redesign section
  only, and re-applied on every variant change (price + button are re-rendered
  by global.js renderProductInfo, which then publishes PUB_SUB_EVENTS.variantChange).
*/
(() => {
  const FALLBACK_LABEL = 'Add to Cart';

  const getPrice = (section) => {
    const block = section.querySelector('.product_price_block');
    if (!block) return '';
    const el =
      block.querySelector('.price__sale .price-item--sale') ||
      block.querySelector('.price__sale .price-item--last') ||
      block.querySelector('.price__regular .price-item--regular') ||
      block.querySelector('.price-item--last');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  const apply = (section) => {
    const button = section.querySelector('[id^="ProductSubmitButton"]');
    const span = button && button.querySelector('span');
    if (!span) return;
    if (button.hasAttribute('disabled')) return; // keep sold-out text
    const label = section.dataset.atcLabel || FALLBACK_LABEL;
    const price = getPrice(section);
    span.textContent = price ? `${label} - ${price}` : label;
  };

  const init = () => {
    const sections = document.querySelectorAll('.main__product--redesign');
    if (!sections.length) return;

    sections.forEach(apply);

    // `subscribe` / `PUB_SUB_EVENTS` are top-level globals (pubsub.js / constants.js),
    // not window properties — reference them bare with a typeof guard.
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(() => sections.forEach(apply));
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
